import React from 'react';
import propTypes from 'prop-types';

const Avatar = props => {

    const {  avatarClass, userImage } = props;

    return (
        <div className={`${avatarClass} avatar-image`} style ={ { backgroundImage: "url("+userImage+")" } }></div>
    )
};


Avatar.propTypes = {
    userImage: propTypes.string,
    avatarClass: propTypes.string,
};



export default Avatar;



// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/Avatar.js